import ConstraintsHandler from './constraints-handler';
import {getLpService} from 'services/sports/factory';

export default class BrowserConstraintsHandler extends ConstraintsHandler {
    private constraintsFactory;
    constructor(args) {
        super(args);

        this.constraintsFactory = getLpService(this.state.sportConfig, {
            store: this.store,
        });

        this.operationData.constraints.base = {
            objective: this.constraintsFactory.exec('prepareMaxSection', {}, {}),
            subjectTo: this.constraintsFactory.exec(
                'subjectToPermanent',
                {
                    sportConfig: this.state.sportConfig,
                },
                {},
            ),
            general: this.constraintsFactory.exec('prepareGeneralSection', {}, {}),
        };
    }

    public getConstraints(): any {
        let constraints = cp(this.operationData.constraints.base);

        constraints.bound = this.constraintsFactory.exec('prepareBoundSection', {}, {});
        constraints.subjectTo = {
            ...this.constraintsFactory.exec(
                'subjectToAlterable',
                {
                    sportConfig: this.state.sportConfig,
                },
                {},
            ),
            ...constraints.subjectTo,
        };

        const maxRandomSection = this.constraintsFactory.exec('prepareMaxRandomSection', {}, {});
        const additionalObjective = this.constraintsFactory.exec('additionalObjective', {});

        const objective = {
            ...constraints.objective.row,
            ...maxRandomSection,
            ...additionalObjective,
        };
        constraints.objective = this.constraintsFactory.exec('convertConstraintsToStr', {
            constraints: [{row: objective}],
        });
        // Avoid overwriting rules by additionalBound.
        const bound = {
            ...this.constraintsFactory.exec('additionalBound', {}),
            ...constraints.bound,
        };
        constraints.bound = this.constraintsFactory.exec('convertBoundToStr', {
            constraints: bound,
        });

        const general = [...constraints.general, ...this.constraintsFactory.exec('additionalGeneral', {})];
        constraints.general = this.constraintsFactory.exec('convertGeneralToStr', {
            arr: general,
        });

        this.operationData.constraints.afterCreating = cp(constraints);

        return this.doExecutable('beforeReturningConstraints');
    }
}
